export default "/static/images/build_roof_2.png?8b6e2b1920720bd525d8873e0afdcd34";